import React, { useEffect, useState } from "react";
import axios from "axios";

const ReasonsToJoin = () => {
  const [reasons, setReasons] = useState([]);
  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/careers`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setReasons(events.levelUp.reasons);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);

  if (reasons.length === 0) {
    return null; // or a loading spinner, or some placeholder
  }




  return (
    <div className="mx-auto px-4 py-10">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">Reasons to Join yslearn</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {reasons.map((reason, index) => (
          <div
            key={index}
            className={`p-6 rounded-lg shadow-md ${index % 2 === 0 ? "bg-yellow-50" : "bg-blue-50"}`}
          >
            <h3 className="text-lg text-center font-bold mb-2">{reason.title}</h3>
            <p className="text-[black] text-justify">{reason.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReasonsToJoin;
